<template>
    <div class="nbaip-container">
        <div class="nbaip-header">
            <img src="../assets/img/nbaip/topBg.png" class="header-bg" alt="" />
            <div class="header-tit">
                <img src="../assets/img/nbaip/topTit.png" alt="" />
            </div>
            <div class="header-img">
                <img src="../assets/img/nbaip/topImg1.png" alt="" />
            </div>
        </div>
        <div class="section1">
            <div class="s1-content">
                <img src="../assets/img/nbaip/s1bg.png" class="section1-bg" alt="" />
                <div class="s1-content-tit">
                    <img src="../assets/img/nbaip/s1tit.png" alt="" />
                </div>
                <div class="s1-content-txt">
                    <h4>SOFTFIRE & NBA联名款童装</h4>
                    <p>无论是在运动场上尽情挥洒汗水，还是在日常生活中展现个性魅力，SOFTFIRE & NBA联名款童装都希望能成为青少年的最佳伙伴。</p>
                    <p>SOFTFIRE品牌主打产品为生活运动童装，力求在舒适性和时尚感之间取得完美平衡。国际知名品牌NBA正版授权，
                        SOFTFIRE于2024年10月重磅推出NBA IP联名款童装产品线。
                    </p>
                </div>
            </div>
            <div class="s1-content-img1">
                <img src="../assets/img/nbaip/s1img1.png" alt="" />
            </div>
            <div class="s1-content-img2">
                <img src="../assets/img/nbaip/s1img2.png" alt="" />
            </div>
        </div>
        <div class="section2">
            <div class="section2_top">
                <img src="../assets/img/nbaip/s2topbg.png" alt="" />
                <div class="section2_top_tit">
                    <img src="../assets/img/nbaip/s2toptit.png" alt="" />
                </div>
                <div class="section2_top_btn">
                    <div class="section2_top_btn_left" 
                         @click="slideLeft" 
                         :class="{ disabled: isLeftDisabled }">
                        <img src="../assets/img/nbaip/s2top_left.png" alt="" />
                    </div>
                    <div class="section2_top_btn_right" 
                         @click="slideRight"
                         :class="{ disabled: isRightDisabled }">
                        <img src="../assets/img/nbaip/s2top_right.png" alt="" />
                    </div>
                </div>
                <div class="section2_top_content">
                    <div class="section2_top_content_wrapper"
                         @touchstart="handleTouchStart"
                         @touchmove="handleTouchMove"
                         @touchend="handleTouchEnd">
                        <div class="section2_top_content_slider" 
                             :style="{ 
                                 transform: `translateX(${slideOffset}px)`,
                                 transition: isDragging ? 'none' : 'transform 0.3s ease-in-out'
                             }">
                            <div class="section2_top_content_model" v-for="(item,index) in models" :key="index">
                                <div class="section2_top_content_model_img">
                                    <img :src="item.img" alt="" />
                                    <div class="model_shadow">
                                        <img src="../assets/img/nbaip/shadow.png" alt="" />
                                    </div>
                                </div>
                                <div class="section2_top_content_model_tit">
                                      <p>{{ item.tit }}</p>
                                      <p>{{ item.en }}</p>
                                </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section2_middle">
                <img src="../assets/img/nbaip/s2_middle_bg.png" class="section2_middle_bg" alt="" />
                <div class="section2_middle_tit">
                    <img src="../assets/img/nbaip/s2_middle_tit.png" alt="" />
                </div>
                <div class="section2_middle_content">
                    <div class="section2_middle_content_sort">
                        <div class="section2_middle_content_sort_list" v-for="(item,index) in sorts" :key="item.key" @click="selected = item.key">
                            <div v-if="selected === item.key" class="section2_middle_content_sort_list_selected">
                                <img src="../assets/img/nbaip/selected.png" class="selected_img" alt="" />
                                <span>{{ item.name }}</span>
                            </div>
                            <div v-else style="padding: 15px 0;">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div class="section2_middle_content_list">
                        <div class="product_grid">
                            <div class="product_item" v-for="(item, index) in currentProducts" :key="index">
                                <img :src="item.image" :alt="item.name" @error="handleImageError" @click="openImageModal(item.image, item.name)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page_bottom">
                <img src="../assets/img/nbaip/bottom.png" alt="" />
            </div>
        </div>
        <div class="loating" v-show="showFloatingButton">
              <div class="loating_img" @click="toggleFloatingTip">
                  <img src="../assets/img/nbaip/right_img.png" alt="" />
                  <div class="loating_close" @click.stop="closeFloatingButton">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                  </div>
              </div>
              <transition name="tip-fade">
                  <div class="loating_tip" v-show="showFloatingTip">
                      <img src="../assets/img/nbaip/right_img_tip.png" alt="" />
                  </div>
              </transition>
        </div>
       
        
        <!-- 图片放大模态框 -->
        <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
            <div class="image-modal-overlay"></div>
            <div class="image-modal-content" @click.stop>
                <img :src="modalImageSrc" :alt="modalImageName" class="modal-image" />
                <button class="modal-close" @click="closeImageModal">&times;</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "NBAIP",
    data() {
        return {
           models:[
                {
                    img:require("../assets/img/nbaip/model/s2model1.png"),
                    tit:"国王队款",
                    en:"King's team funds"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model2.png"),
                    tit:"经典三色款式",
                    en:"Classic three-color style"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model3.png"),
                    tit:"活力绿色休闲款",
                    en:"Energetic green casual style"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model4.png"),
                    tit:"经典彩蓝色款",
                    en:"Classic blue style"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model5.png"),
                    tit:"金州勇士队款",
                    en:"Golden State Warriors"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model6.png"),
                    tit:"城市主题款",
                    en:"City theme style"
                },
                {
                    img:require("../assets/img/nbaip/model/s2model7.png"),
                    tit:"复古经典款",
                    en:"Retro classic style"
                },
           ],
           currentSlideIndex: 0, // 当前滑动位置
           slideOffset: 0, // 滑动偏移量
           itemsPerView: 2.2, // 显示2.2个项目，确保最后一项可见
           itemWidth: 140, // 匹配CSS中的更小模型宽度
           // 触摸滑动相关
           touchStartX: 0,
           touchEndX: 0,
           isDragging: false,
           startOffset: 0,
           sorts:[
                {key:"T-shirt",name:"T恤"},
                {key:"pants",name:"裤子"},
                {key:"backpack",name:"包包"},
                {key:"suit",name:"套装"},
                {key:"hat",name:"帽子"}
           ],
           selected:"T-shirt",
           // 图片模态框相关数据
           showImageModal: false,
           modalImageSrc: '',
                     // floating tip显示控制
          showFloatingTip: false,
          // floating按钮显示控制
          showFloatingButton: true,
           modalImageName: '',
           // 产品数据
           products: {
               "T-shirt": [
                   { name: "T恤1", image: require("../assets/img/nbaip/sku/T恤/1.png") },
                   { name: "T恤2", image: require("../assets/img/nbaip/sku/T恤/2.png") },
                   { name: "T恤3", image: require("../assets/img/nbaip/sku/T恤/3.png") },
                   { name: "T恤4", image: require("../assets/img/nbaip/sku/T恤/4.png") },
                   { name: "T恤5", image: require("../assets/img/nbaip/sku/T恤/5.png") },
                   { name: "T恤6", image: require("../assets/img/nbaip/sku/T恤/6.png") },
                   { name: "T恤7", image: require("../assets/img/nbaip/sku/T恤/7.png") },
                   { name: "T恤8", image: require("../assets/img/nbaip/sku/T恤/8.png") },
                   { name: "T恤9", image: require("../assets/img/nbaip/sku/T恤/9.png") },
                   { name: "T恤10", image: require("../assets/img/nbaip/sku/T恤/10.png") },
                   { name: "T恤11", image: require("../assets/img/nbaip/sku/T恤/11.png") },
                   { name: "T恤12", image: require("../assets/img/nbaip/sku/T恤/12.png") },
                   { name: "T恤13", image: require("../assets/img/nbaip/sku/T恤/13.png") },
                   { name: "T恤14", image: require("../assets/img/nbaip/sku/T恤/14.png") },
                   { name: "T恤15", image: require("../assets/img/nbaip/sku/T恤/15.png") },
                   { name: "T恤16", image: require("../assets/img/nbaip/sku/T恤/16.png") },
                   { name: "T恤17", image: require("../assets/img/nbaip/sku/T恤/17.png") },
                   { name: "T恤18", image: require("../assets/img/nbaip/sku/T恤/18.png") },
                   { name: "T恤19", image: require("../assets/img/nbaip/sku/T恤/19.png") },
                   { name: "T恤20", image: require("../assets/img/nbaip/sku/T恤/20.png") },
                   { name: "T恤21", image: require("../assets/img/nbaip/sku/T恤/21.png") },
                   { name: "T恤22", image: require("../assets/img/nbaip/sku/T恤/22.png") },
                   { name: "T恤23", image: require("../assets/img/nbaip/sku/T恤/23.png") },
                   { name: "T恤24", image: require("../assets/img/nbaip/sku/T恤/24.png") },
                   { name: "T恤25", image: require("../assets/img/nbaip/sku/T恤/25.png") },
                   { name: "T恤26", image: require("../assets/img/nbaip/sku/T恤/26.png") },
                   { name: "T恤27", image: require("../assets/img/nbaip/sku/T恤/27.png") },
                   { name: "T恤28", image: require("../assets/img/nbaip/sku/T恤/28.png") },
                   { name: "T恤29", image: require("../assets/img/nbaip/sku/T恤/29.png") },
                   { name: "T恤30", image: require("../assets/img/nbaip/sku/T恤/30.png") }
               ],
               "pants": [
                   { name: "裤子1", image: require("../assets/img/nbaip/sku/裤子/1.png") },
                   { name: "裤子2", image: require("../assets/img/nbaip/sku/裤子/2.png") },
                   { name: "裤子3", image: require("../assets/img/nbaip/sku/裤子/3.png") },
                   { name: "裤子4", image: require("../assets/img/nbaip/sku/裤子/4.png") },
                   { name: "裤子5", image: require("../assets/img/nbaip/sku/裤子/5.png") },
                   { name: "裤子6", image: require("../assets/img/nbaip/sku/裤子/6.png") },
                   { name: "裤子7", image: require("../assets/img/nbaip/sku/裤子/7.png") },
                   { name: "裤子8", image: require("../assets/img/nbaip/sku/裤子/8.png") },
                   { name: "裤子9", image: require("../assets/img/nbaip/sku/裤子/9.png") },
                   { name: "裤子10", image: require("../assets/img/nbaip/sku/裤子/10.png") },
                   { name: "裤子12", image: require("../assets/img/nbaip/sku/裤子/12.png") },
                   { name: "裤子13", image: require("../assets/img/nbaip/sku/裤子/13.png") },
                   { name: "裤子14", image: require("../assets/img/nbaip/sku/裤子/14.png") },
                   { name: "裤子15", image: require("../assets/img/nbaip/sku/裤子/15.png") }
               ],
               "backpack": [
                   { name: "包包1", image: require("../assets/img/nbaip/sku/包包/1.png") },
                   { name: "包包2", image: require("../assets/img/nbaip/sku/包包/2.png") },
                   { name: "包包1", image: require("../assets/img/nbaip/sku/包包/3.png") },
                   { name: "包包2", image: require("../assets/img/nbaip/sku/包包/5.png") },
                   { name: "包包3", image: require("../assets/img/nbaip/sku/包包/6.png") },
                   { name: "包包4", image: require("../assets/img/nbaip/sku/包包/9.png") },
                   { name: "包包5", image: require("../assets/img/nbaip/sku/包包/10.png") },
                   { name: "包包6", image: require("../assets/img/nbaip/sku/包包/11.png") },
                   { name: "包包7", image: require("../assets/img/nbaip/sku/包包/13.png") },
                   { name: "包包8", image: require("../assets/img/nbaip/sku/包包/112.png") }
               ],
               "suit": [
                   { name: "套装1", image: require("../assets/img/nbaip/sku/套装/未标题-1.png") },
                   { name: "套装2", image: require("../assets/img/nbaip/sku/套装/未标题-13.png") },
                   { name: "套装3", image: require("../assets/img/nbaip/sku/套装/AgAABXq0GNc5WyvSHb1M3prxK3eSJlNN.jpeg") },
                   { name: "套装4", image: require("../assets/img/nbaip/sku/套装/AgAABXq0GNc7Y6MXAGlMy50NxFyQXLzR.jpeg") },
                   { name: "套装5", image: require("../assets/img/nbaip/sku/套装/AgAABXq0GNeEQvCEX6BLq5-0Vk76EZfF.jpeg") },
                   { name: "套装6", image: require("../assets/img/nbaip/sku/套装/AgAABXq0GNfIZ81YVcRNl6IWIx14hCPl.jpeg") }
               ],
               "hat": [
                   { name: "帽子1", image: require("../assets/img/nbaip/sku/帽子/帽子.jpeg") },
                   { name: "帽子2", image: require("../assets/img/nbaip/sku/帽子/AgAABXq0GNc144mCXglEDqLnoCaUpn07.jpeg") },
                   { name: "帽子3", image: require("../assets/img/nbaip/sku/帽子/AgAABXq0GNddPoXQzPJCSJzNvsHLGnlw.jpeg") },
                   { name: "帽子4", image: require("../assets/img/nbaip/sku/帽子/AgAABXq0GNf8seHd3VhIbp4hyBS_B3dy.jpeg") },
                   { name: "帽子5", image: require("../assets/img/nbaip/sku/帽子/AgAABXq0GNfiLyDlDWlN0Jw_HsHBi8eb.jpeg") }
               ]
           }
        };
    },
    computed: {
        // 根据选中分类返回对应产品
        currentProducts() {
            return this.products[this.selected] || [];
        },
        isLeftDisabled() {
            return this.currentSlideIndex === 0;
        },
        isRightDisabled() {
            if (!this.models || !this.models.length) return true;
            
            // 计算一次可以完整显示的项目数量
            const fullItemsVisible = Math.floor(this.itemsPerView);
            
            // 如果总项目数小于等于可见项目数，则不需要滑动
            if (this.models.length <= fullItemsVisible) return true;
            
            // 计算最大滑动索引
            // 要显示最后一个模型（索引 models.length-1），并且要显示 fullItemsVisible 个完整项目
            // 起始索引最大为：(models.length-1) - (fullItemsVisible-1) = models.length - fullItemsVisible
            const maxSlideIndex = this.models.length - fullItemsVisible;
            
            return this.currentSlideIndex >= maxSlideIndex;
        }
    },
    mounted() {
        // 初始化时计算每个项目的宽度（可以根据屏幕大小调整）
        this.updateItemWidth();
        window.addEventListener('resize', this.updateItemWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateItemWidth);
    },
    methods:{
        slideLeft() {
            // 向左滑动，显示前面的项目
            if (!this.isLeftDisabled && this.currentSlideIndex > 0) {
                this.currentSlideIndex--;
                this.slideOffset = -this.currentSlideIndex * (this.itemWidth + 12); // 加上margin-right
            }
        },
        slideRight() {
            // 向右滑动，显示后面的项目
            if (!this.isRightDisabled && this.models && this.models.length) {
                const fullItemsVisible = Math.floor(this.itemsPerView);
                const maxSlideIndex = this.models.length - fullItemsVisible;
                
                if (this.currentSlideIndex < maxSlideIndex) {
                    this.currentSlideIndex++;
                    this.slideOffset = -this.currentSlideIndex * (this.itemWidth + 12); // 加上margin-right
                }
            }
        },
        updateItemWidth() {
            // 专门针对移动设备优化，让模型显示更大
            const screenWidth = window.innerWidth;
            console.log('Screen width:', screenWidth);
            
            if (screenWidth <= 360) {
                // 小屏手机：显示1.8个，让模型更大更突出
                this.itemsPerView = 1.8;
                this.itemWidth = 180;
            } else if (screenWidth <= 393) {
                // 中屏手机：显示2个，模型大小适中
                this.itemsPerView = 2;
                this.itemWidth = 170;
            } else {
                // 大屏手机及以上：显示2.2个，保持良好视觉效果
                this.itemsPerView = 2.2;
                this.itemWidth = 160;
            }
            
            // 重置滑动位置，确保不超出边界
            this.currentSlideIndex = 0;
            this.slideOffset = 0;
        },
        // 添加键盘导航支持（可选）
        handleKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                this.slideLeft();
            } else if (event.key === 'ArrowRight') {
                this.slideRight();
            }
        },
        // 触摸开始
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.isDragging = true;
            this.startOffset = this.slideOffset;
        },
        // 触摸移动
        handleTouchMove(event) {
            if (!this.isDragging) return;
            
            event.preventDefault(); // 防止页面滚动
            this.touchEndX = event.touches[0].clientX;
            const deltaX = this.touchEndX - this.touchStartX;
            
            // 实时更新滑动位置
            const newOffset = this.startOffset + deltaX;
            const maxOffset = -(Math.max(0, this.models.length - Math.floor(this.itemsPerView))) * (this.itemWidth + 12);
            
            // 限制滑动范围，防止超出边界
            if (newOffset <= 0 && newOffset >= maxOffset) {
                this.slideOffset = newOffset;
            } else {
                // 当到达边界时，完全阻止移动
                if (newOffset > 0) {
                    // 已经在最左侧（第一项），不允许继续右滑
                    this.slideOffset = 0;
                } else if (newOffset < maxOffset) {
                    // 已经在最右侧，不允许继续左滑
                    this.slideOffset = maxOffset;
                }
            }
        },
        // 触摸结束
        handleTouchEnd(event) {
            if (!this.isDragging) return;
            
            this.isDragging = false;
            const deltaX = this.touchEndX - this.touchStartX;
            const threshold = 50; // 滑动阈值
            
            if (Math.abs(deltaX) > threshold) {
                if (deltaX > 0 && !this.isLeftDisabled) {
                    // 向右滑动，显示前面的内容，但要检查是否可以左滑
                    this.slideLeft();
                } else if (deltaX < 0 && !this.isRightDisabled) {
                    // 向左滑动，显示后面的内容，但要检查是否可以右滑
                    this.slideRight();
                } else {
                    // 到达边界，回弹到当前正确位置
                    this.slideOffset = -this.currentSlideIndex * (this.itemWidth + 12);
                }
            } else {
                // 滑动距离不够，回弹到原位置
                this.slideOffset = -this.currentSlideIndex * (this.itemWidth + 12);
            }
        },
        // 处理图片加载错误
        handleImageError(event) {
            console.log('图片加载失败:', event.target.src);
            // 可以设置一个默认图片
            // event.target.src = require("../assets/img/default-product.png");
        },
        // 打开图片模态框
        openImageModal(imageSrc, imageName) {
            this.modalImageSrc = imageSrc;
            this.modalImageName = imageName;
            this.showImageModal = true;
            // 阻止页面滚动
            document.body.style.overflow = 'hidden';
        },
        // 关闭图片模态框
        closeImageModal() {
            this.showImageModal = false;
            this.modalImageSrc = '';
            this.modalImageName = '';
            // 恢复页面滚动
            document.body.style.overflow = 'auto';
        },
        // 切换floating tip显示状态
        toggleFloatingTip() {
            this.showFloatingTip = !this.showFloatingTip;
        },
        // 关闭floating按钮
        closeFloatingButton() {
            this.showFloatingButton = false;
            this.showFloatingTip = false;
        }
    }
};
</script>

<style scoped lang="scss">
.nbaip-container{
    width: 100%;
    .nbaip-header{
        margin-top: 4rem;
        position: relative;
        width: 100%;
        height: auto;
        overflow: hidden;
        .header-bg{
            width: 100%;
            height: auto;
            display: block;
            object-fit: contain; /* 保持图片比例 */
        }
        .header-tit{
            position: absolute;
            top: 27%;
            left: 14%;
            width: 67%;
        }
        .header-img{
            position: absolute;
            top: 23%;
            left: 54%;
            width: 54%;
        }
    }
    .section1{
        width: 100%;
        height: 400px;
        background-color: #FDF1D8;
        overflow: hidden;
        position: relative;
        
        .s1-content-img1{
            width: 49%;
            position: absolute;
            bottom: -18%;
            left: -14%;
            z-index: 1;
        }
        .s1-content-img2{
            width: 12%;
            position: absolute;
            bottom: 3%;
            left: 25%;
        }
        .s1-content{
            width:95%;
            margin: 0 auto;
            margin-top: 2rem;
            position: relative;

            .section1-bg{
                object-fit: contain; /* 保持图片比例 */
                z-index: -1;
            }
            .s1-content-tit{
                position: absolute;
                top: 3%;
                left: 28%;
                width: 45%;
            }
            .s1-content-txt{
                position: absolute;
                top: 28%;
                left: 15%;
                width: 75%;
                text-align: center;
                color: #fff;
                h4{
                    color: #fff;
                    font-size: 1rem;
                    font-weight: 600;
                    margin-bottom: 0.8rem;
                }
                p{
                    font-size: 0.6rem;
                }
            }
        }
        
        /* 平板设备适配 (768px - 1024px) */
        @media screen and (max-width: 1024px) and (min-width: 769px) {
            height: 800px;
            
            .s1-content-img1{
                width: 55%;
                bottom: -20%;
                left: -15%;
            }
            .s1-content-img2{
                width: 15%;
                bottom: 5%;
                left: 28%;
            }
            .s1-content{
                .s1-content-tit{
                    top: 5%;
                    left: 33%;
                    width: 45%;
                }
                .s1-content-txt{
                    top: 30%;
                    left: 16%;
                    width: 80%;
                    h4{
                        font-size: 2rem;
                        margin: 0.8rem;
                    }
                    p{
                        font-size: 1rem;
                        line-height: 1.4;
                    }
                }
            }
        }
        /* 手机横屏适配 (481px - 768px) */
        @media screen and (max-width: 768px) and (min-width: 481px) {
            height: 450px;
            
            .s1-content-img1{
                width: 48%;
                bottom: -18%;
                left: -18%;
            }
            .s1-content-img2{
                width: 13%;
                bottom: 2%;
                left: 20%;
            }
            .s1-content{
                margin-top: 1.5rem;
                .s1-content-tit{
                    top: 2%;
                    left: 32%;
                    width: 45%;
                }
                .s1-content-txt{
                    top: 27%;
                    left: 15%;
                    width: 80%;
                    h4{
                        font-size: 1.5rem;
                        margin-bottom: 1rem;
                    }
                    p{
                        font-size: 0.8rem;
                        line-height: 1.2rem;
                    }
                }
            }
        }
        @media screen and (max-width: 414px){
            height: 350px;
            
            .s1-content-img1{
                width: 50%;
                bottom: -18%;
                left: -15%;
            }
            .s1-content-img2{
                width: 12%;
                bottom: 6%;
                left: 25%;
            }
            .s1-content{
                margin-top: 1.5rem;
                .s1-content-tit{
                    top: 8%;
                    left: 30%;
                    width: 38%;
                }
                .s1-content-txt{
                    top: 30%;
                    left: 18%;
                    width: 65%;
                    h4{
                        font-size: 0.8rem;
                        margin-bottom: 0.4rem;
                    }
                    p{
                        font-size: 0.5rem;
                        line-height: 1.3;
                        margin-bottom: 0.3rem;
                    }
                }
            }
        }
        
        /* 手机竖屏适配 (320px - 480px) */
        @media screen and (max-width: 480px) {
            // height: 400px;
            
            // .s1-content-img1{
            //     width: 35%;
            //     bottom: -5%;
            //     left: -5%;
            // }
            // .s1-content-img2{
            //     width: 6%;
            //     bottom: 10%;
            //     left: 32%;
            // }
            // .s1-content{
            //     margin-top: 1rem;
            //     .s1-content-tit{
            //         top: 10%;
            //         left: 35%;
            //         width: 30%;
            //     }
            //     .s1-content-txt{
            //         top: 40%;
            //         left: 22%;
            //         width: 60%;
            //         h4{
            //             font-size: 0.7rem;
            //             margin-bottom: 0.5rem;
            //         }
            //         p{
            //             font-size: 0.45rem;
            //             line-height: 1.2;
            //             margin-bottom: 0.2rem;
            //         }
            //     }
            // }
        }
        
        /* 小屏手机适配 (320px以下) */
        @media screen and (max-width: 320px) {
            height: 180px;
            
            .s1-content-img1{
                width: 30%;
                bottom: 0%;
                left: -3%;
            }
            .s1-content-img2{
                width: 5%;
                bottom: 12%;
                left: 34%;
            }
            .s1-content{
                margin-top: 0.8rem;
                .s1-content-tit{
                    top: 12%;
                    left: 37%;
                    width: 26%;
                }
                .s1-content-txt{
                    top: 45%;
                    left: 25%;
                    width: 55%;
                    h4{
                        font-size: 0.6rem;
                        margin-bottom: 0.4rem;
                    }
                    p{
                        font-size: 0.4rem;
                        line-height: 1.1;
                        margin-bottom: 0.15rem;
                    }
                }
            }
        }
    }
    .section2{
        width: 100%;
        background-color: #FDF1D8;
        overflow: hidden;
        .section2_top{
            width: 100%;
            position: relative;
            margin-bottom: 100px;
            &_tit{
                width: 20%;
                position: absolute;
                left: 15%;
                top: 15%;
            }
            &_btn{
                width: 75%;
                position: absolute;
                left: 77%;
                top: 22%;
                display: flex;
                &_left{
                    width: 6%;
                    margin-right: 0.5rem;
                    cursor: pointer;
                    transition: opacity 0.3s ease;
                    
                    &:hover{
                        opacity: 0.8;
                    }
                    
                    &:active{
                        transform: scale(0.95);
                    }
                    
                    &.disabled{
                        opacity: 0.3;
                        cursor: not-allowed;
                        pointer-events: none;
                        
                        &:hover, &:active{
                            opacity: 0.3;
                            transform: none;
                        }
                    }
                }
                &_right{
                    width: 6%;
                    cursor: pointer;
                    transition: opacity 0.3s ease;
                    
                    &:hover{
                        opacity: 0.8;
                    }
                    
                    &:active{
                        transform: scale(0.95);
                    }
                    
                    &.disabled{
                        opacity: 0.3;
                        cursor: not-allowed;
                        pointer-events: none;
                        
                        &:hover, &:active{
                            opacity: 0.3;
                            transform: none;
                        }
                    }
                }
            }
            &_content{
                position: absolute;
                left: 24%;
                top: 40%;
                overflow: hidden;
                padding-right: 20px; /* 为最后一项留出显示空间 */
                
                &_wrapper{
                    width: 100%;
                    height: 100%;
                    touch-action: pan-x; /* 只允许水平滑动 */
                    user-select: none; /* 防止选择文本 */
                    cursor: grab;
                    
                    &:active {
                        cursor: grabbing;
                    }
                }
                
                &_slider{
                    display: flex;
                    /* transition 现在通过 Vue 动态控制 */
                }
                
                &_model{
                    width: 160px; /* 增大默认宽度，适配移动设备 */
                    margin-right: 10px; 
                    
                    &_img{
                        position: relative;
                        
                        .model_shadow{
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            z-index: 1;
                            
                            img{
                                width: 100%;
                                height: auto;
                            }
                        }
                    }
                    
                    &_tit{
                        p{
                            font-size: 0.7rem;
                            color: #333;
                            
                            // &:first-child{
                            //     font-weight: bold;
                            // }
                            
                            &:last-child{
                                font-size: 0.6rem;
                                color: #666;
                            }
                        }
                    }
                }
            }
        }
        
        /* 移动设备专用响应式适配 - 直接针对模型容器 */
        
        /* 通用移动设备适配 */
        @media screen and (max-width: 768px) {
            .section2_top_content_model {
                min-width: 130px !important; /* 更小的最小宽度 */
                max-width: 150px !important; /* 更小的最大宽度 */
            }
        }
        
        /* 小屏手机 (360px及以下) - iPhone SE等 */
        @media screen and (max-width: 360px) {
            .section2_top_content {
                left: 28% !important;
                width: 90% !important; /* 增加容器宽度以显示更多内容 */
                /* 移除 overflow: visible，让滑动功能正常工作 */
            }
            
            .section2_top_content_model {
                width: 130px !important; /* 更小尺寸 */
                margin-right: 12px !important; /* 增加间距确保最后项目可见 */
            }
            
            .section2_top_content_model_tit p {
                font-size: 0.7rem !important;
            }
            
            .section2_top_content_model_tit p:last-child {
                font-size: 0.6rem !important;
            }
        }
        
        /* 中屏手机 (361px - 393px) - iPhone 14 Pro等 */
        @media screen and (min-width: 361px) and (max-width: 393px) {
            .section2_top_content {
                left: 28% !important;
                width: 90% !important; /* 增加容器宽度 */
                /* 移除 overflow: visible，让滑动功能正常工作 */
            }
            
            .section2_top_content_model {
                width: 140px !important; /* 更小尺寸 */
                margin-right: 12px !important;
            }
            
            .section2_top_content_model_tit p {
                font-size: 0.75rem !important;
            }
            
            .section2_top_content_model_tit p:last-child {
                font-size: 0.65rem !important;
            }
        }
        
        /* 大屏手机 (394px及以上) - iPhone 14 Pro Max等 */
        @media screen and (min-width: 394px) {
            .section2_top_content {
                left: 28% !important;
                width: 90% !important; /* 增加容器宽度 */
                /* 移除 overflow: visible，让滑动功能正常工作 */
            }
            
            .section2_top_content_model {
                width: 150px !important; /* 更小的大屏尺寸 */
                margin-right: 12px !important;
            }
            
            .section2_top_content_model_tit p {
                font-size: 0.8rem !important;
            }
            
            .section2_top_content_model_tit p:last-child {
                font-size: 0.7rem !important;
            }
        }

       &_middle{
        // width: 95%;
        // height: auto;
        position: relative;
        margin: 30px 10px;
        // &_bg{
        //     height: 200px;
        // }
        &_tit{
            position: absolute;
            width: 45%;
            top: 8%;
            left: 15%;
        }
        &_content{
            position: absolute;
            top: 15%;
            left: 5%;
            max-height: 440px;
            width: 100%;
            display: flex;
            &_sort{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                width: 5%;
                max-height: 440px;
                font-size: 0.8rem;
                background-color: #FFE0AF;
                border-radius: 15px;
                text-align: center;
                &_list{
                    &_selected{
                        display: flex;
                        justify-content: flex-end;
                        position: relative;
                        // width: 100%;
                        .selected_img{
                            width: 130%;
                        }
                        span{
                            position: absolute;
                            left: 0;
                            top: 0;
                            color: #fff;
                        }
                    }
                }
            }
            &_list{
                // margin-left: 8%;
                width: 90%;
                min-height: 420px;
                overflow-y: auto;
                
                .product_grid{
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 5px;
                    padding:5px 12px 10px 12px;
                    
                    .product_item{
                        background: #fff;
                        border-radius: 10px;
                        // padding: 10px;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                        cursor: pointer;
                        
                        img{
                            width: 100%;
                            object-fit: contain;
                            border-radius: 10px;
                            transition: transform 0.3s ease;
                        }
                        
                        &:hover img{
                            transform: scale(1.05);
                        }
                    }
                }
                
                /* 移动端适配 */
                // @media screen and (max-width: 768px) {
                //     margin-left: 6%;
                //     width: 88%;
                    
                //     .product_grid{
                //         grid-template-columns: repeat(3, 1fr);
                //         gap: 10px;
                //         padding: 15px;
                        
                //         .product_item{
                //             padding: 8px;
                            
                //             img{
                //                 height: 100px;
                //             }
                //         }
                //     }
                // }
                
                // @media screen and (max-width: 480px) {
                //     margin-left: 8%;
                //     width: 85%;
                    
                //     .product_grid{
                //         grid-template-columns: repeat(2, 1fr);
                //         gap: 8px;
                //         padding: 10px;
                        
                //         .product_item{
                //             padding: 6px;
                            
                //             img{
                //                 height: 80px;
                //             }
                //         }
                //     }
                // }
        
               
            }
             @media screen and (min-width: 394px) {
                    .section2_middle_content_sort{
                        height: 480px;

                    }
                    .section2_middle_content_list{
                        height: 490px;
                    }
                }
            }
       }
       .page_bottom{
         width: 100%;
         img {
             width: 100%;
             height: auto;
             display: block;
         }
       }
    }
}

/* 图片模态框样式 */
.image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .image-modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(5px);
    }
    
    .image-modal-content {
        position: relative;
        max-width: 90%;
        max-height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        
        .modal-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            border-radius: 10px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
            animation: modalImageFadeIn 0.3s ease-out;
        }
        
        .modal-close {
            position: absolute;
            top: -15px;
            right: -15px;
            background: rgba(255, 255, 255, 0.9);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            transition: all 0.2s ease;
            
            &:hover {
                background: rgba(255, 255, 255, 1);
                transform: scale(1.1);
            }
        }
    }
}

/* 模态框动画 */
@keyframes modalImageFadeIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* 移动端优化 */
@media screen and (max-width: 768px) {
    .image-modal {
        .image-modal-content {
            max-width: 95%;
            max-height: 85%;
            
            .modal-close {
                top: -10px;
                right: -10px;
                width: 35px;
                height: 35px;
                font-size: 20px;
            }
        }
    }
}

.loating{
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    
    &_img{
        width: 80px;
        position: relative;
    }
    
    &_close{
        position: absolute;
        top: -20px;
        right: 0;
        width: 20px;
        height: 20px;
        background: #FF5924;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        box-shadow: 0 2px 6px rgba(255, 89, 36, 0.3);
        transition: all 0.2s ease;
        z-index: 10;
        
        &:hover {
            background: #e64a1f;
            transform: scale(1.1);
            box-shadow: 0 3px 8px rgba(255, 89, 36, 0.4);
        }
        
        &:active {
            transform: scale(0.95);
        }
        
        svg {
            width: 12px;
            height: 12px;
        }
    }
    
          &_tip{
          position: absolute;
          left: -130px;
          top: 0;
          width: 140px;
      }
  }

  // Vue transition 动画
  .tip-fade-enter-active, .tip-fade-leave-active {
      transition: all 0.3s ease;
  }
  
  .tip-fade-enter-from, .tip-fade-leave-to {
      opacity: 0;
      transform: translateX(20px);
  }
  
  .tip-fade-enter-to, .tip-fade-leave-from {
      opacity: 1;
      transform: translateX(0);
  }
</style>



// WEBPACK FOOTER //
// src/page/NBAIP.vue